/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Runs_Column_TriggerInputs */

const en_automation_runs_column_trigger = /** @type {(inputs: Automation_Runs_Column_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trigger`)
};

const pt_br2_automation_runs_column_trigger = /** @type {(inputs: Automation_Runs_Column_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatilho`)
};

/**
* | output |
* | --- |
* | "Trigger" |
*
* @param {Automation_Runs_Column_TriggerInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_runs_column_trigger = /** @type {((inputs?: Automation_Runs_Column_TriggerInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Runs_Column_TriggerInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_runs_column_trigger(inputs)
	return pt_br2_automation_runs_column_trigger(inputs)
});